// 社内ログインIDをチェックする
export function isAdminUserId(str) {
  const reg = /^([0-9A-Za-z\-_\.]+)@(tokometal.co.jp|trimetals.co.jp)$/
  return reg.test(str)
}
export function isEmail(str) {
  const reg = /^([a-zA-Z0-9])+([a-zA-Z0-9\.\+\&_-])*@([a-zA-Z0-9])+([a-zA-Z0-9\._-]{1,4})+\.([a-zA-Z]{2,})$/
  return reg.test(str)
}
export function isUserId(str) {
  const reg = /^(([a-zA-Z0-9]){9,9})$/
  return reg.test(str)
}
export function isNumber(str) {
  const reg = /^(([0-9]){10,11})$/
  return reg.test(str)
}
// パスワードを変更
export function isValidPwd(str) {
  const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
  return reg.test(str)
}
// 名前をチェック
export function isName(str) {
  const reg = /^(([a-zA-Z\u0800-\u4e00\u4e00-\u9fa5]){1,10})$/
  return reg.test(str)
}
// カナをチェック
export function isKana(str) {
  const reg = /^(([ァ-ヶa-zA-Z]){1,10})$/
  return reg.test(str)
}
// 会社名前をチェック
export function isCompName(str) {
  const reg = /^(([a-zA-Z\u0800-\u4e00\u4e00-\u9fa5]){0,255})+$/
  return reg.test(str)
}
// 電話番号をチャック
export function isTel(str) {
  const reg = /^([0-9]){0,4}$/
  return reg.test(str)
}
// 電話番号をチャック
export function isTel2(str) {
  const reg = /^([0-9]){0,4}$/
  return reg.test(str)
}
export function isNumberCheck(str) {
  const reg = /^([0-9]){0,}$/
  return reg.test(str)
}



// WEBPACK FOOTER //
// ./src/assets/js/check.js